export const ADD_BUILDING = 'ADD_BUILDING';
export const ADD_BUILDING_SUCCESS = 'ADD_BUILDING_SUCCESS';
export const ADD_BUILDING_FAILED = 'ADD_BUILDING_FAILED';

export const GET_BUILDING = 'GET_BUILDING';
export const GET_BUILDING_SUCCESS = 'GET_BUILDING_SUCCESS';
export const GET_BUILDING_FAILED = 'GET_BUILDING_FAILED';

export const GET_BUILDINGS = 'GET_BUILDINGS';
export const GET_BUILDINGS_SUCCESS = 'GET_BUILDINGS_SUCCESS';
export const GET_BUILDINGS_FAILED = 'GET_BUILDINGS_FAILED';

export const UPDATE_BUILDING = 'UPDATE_BUILDING';
export const UPDATE_BUILDING_SUCCESS = 'UPDATE_BUILDING_SUCCESS';
export const UPDATE_BUILDING_FAILED = 'UPDATE_BUILDING_FAILED';

export const GET_BUILDING_DWELLINGS = 'GET_BUILDING_DWELLINGS';
export const GET_BUILDING_DWELLINGS_SUCCESS = 'GET_BUILDING_DWELLINGS_SUCCESS';
export const GET_BUILDING_DWELLINGS_FAILED = 'GET_BUILDING_DWELLINGS_FAILED';

export const UPLOAD_BUILDING_FILES = 'UPLOAD_BUILDING_FILES';
export const UPLOAD_BUILDING_FILES_SUCCESS = 'UPLOAD_BUILDING_FILES_SUCCESS';
export const UPLOAD_BUILDING_FILES_FAILED = 'UPLOAD_BUILDING_FILES_FAILED';

export const REMOVE_BUILDING_FILE = 'REMOVE_BUILDING_FILE';
export const REMOVE_BUILDING_FILE_SUCCESS = 'REMOVE_BUILDING_FILE_SUCCESS';
export const REMOVE_BUILDING_FILE_FAILED = 'REMOVE_BUILDING_FILE_FAILED';
